import type { products } from "@/constants/content"

type Props = {
  product: (typeof products)[number]
}

const ProductCardVisual = ({ product }: Props) => {
  const VisualComponent = product.visual

  return <VisualComponent />
}

export default ProductCardVisual
